import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "@/components/phone-field.css";

// International phone input — supports every country.
// Stores the value in E.164 format (e.g. +32470366956).
export function PhoneField({ value, onChange, defaultCountry = "BE", testId, className = "" }) {
  return (
    <div className={`gts-phone ${className}`} data-testid={testId}>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry={defaultCountry}
        value={value || undefined}
        onChange={(v) => onChange(v || "")}
        numberInputProps={{ className: "gts-phone-input" }}
      />
    </div>
  );
}
